<template>
  <span class="drag-handle block cursor-pointer">
    <MenuAlt4Icon class="w-5 h-5" />
  </span>
</template>

<script>
import { MenuAlt4Icon } from "@heroicons/vue/outline";

export default {
    mounted() {
        this.$el.sortableHandle = true;
    },
    components: {
        MenuAlt4Icon
    }
};
</script>
